export function parseBadgeTagIds(raw) {
    return (typeof raw === "string" ? raw : "")
        .split(",")
        .map((id) => id.trim())
        .filter((id) => id !== "");
}

export function selectBadgeTags(tags, order) {
    if (!Array.isArray(tags)) {
        return [];
    }

    return tags
        .filter(
            (tag) =>
                tag && tag.names && tag.names.name && order.includes(String(tag.id))
        )
        .sort((a, b) => order.indexOf(String(a.id)) - order.indexOf(String(b.id)));
}

export function normalizeHexColor(color) {
    if (typeof color !== "string") {
        return null;
    }

    let hex = color.replace("#", "");

    if (hex.length === 3) {
        hex = hex.replace(/(.)/g, "$1$1");
    }

    return /^[0-9a-fA-F]{6}$/.test(hex) ? hex : null;
}

export function contrastColor(hex) {
    const toLinear = (channel) =>
        channel <= 0.03928
            ? channel / 12.92
            : Math.pow((channel + 0.055) / 1.055, 2.4);

    const r = toLinear(parseInt(hex.substring(0, 2), 16) / 255);
    const g = toLinear(parseInt(hex.substring(2, 4), 16) / 255);
    const b = toLinear(parseInt(hex.substring(4, 6), 16) / 255);

    return 0.2126 * r + 0.7152 * g + 0.0722 * b > 0.179 ? "#000000" : "#ffffff";
}

export function badgeTagStyle(tag) {
    const hex = normalizeHexColor(tag && tag.color);

    if (!hex) {
        return {};
    }

    return { backgroundColor: `#${hex}`, color: contrastColor(hex) };
}

// Ceres reads the slug back as the page headline and turns "_" into a space,
// so the slug keeps the tag name verbatim and only swaps what the route or a
// URL cannot carry. plentymarkets matches the trailing _t<id>, never the slug.
export function tagSlug(name) {
    const slug = (typeof name === "string" ? name : "")
        .trim()
        .replace(/\s+/g, "_")
        .replace(/\//g, "-");

    return slug ? encodeURIComponent(slug) : "";
}

export function tagPageUrl(tag, urlOptions) {
    const slug = tagSlug(tag && tag.names && tag.names.name);

    if (!slug || !tag.id) {
        return null;
    }

    const options = urlOptions || {};
    const prefix = options.includeLanguage && options.language
        ? `/${options.language}`
        : "";

    return `${prefix}/${slug}_t${tag.id}`;
}

export function badgeTagUrlOptions() {
    const app = typeof App === "undefined" ? {} : App;

    return {
        language: app.language,
        includeLanguage: !!(app.urls && app.urls.includeLanguage)
    };
}

export function badgeTagHref(tag, links, scope, surface, urlOptions) {
    if ((scope !== "both" && scope !== surface) || !tag) {
        return null;
    }

    const link = Array.isArray(links)
        ? links.find((entry) => entry && String(entry.id) === String(tag.id))
        : null;

    return (link && link.url) || tagPageUrl(tag, urlOptions);
}

export function badgeTagLinkAttrs(target) {
    return target === "_blank"
        ? { target: "_blank", rel: "noopener noreferrer" }
        : {};
}

export function resolveBadgeSlots(tagIds, hasCrossPrice, hasCategoryDiscount) {
    const slots = hasCrossPrice ? ["discount"] : [];

    return slots
        .concat(tagIds, hasCategoryDiscount ? ["category-discount"] : [])
        .slice(0, 2);
}
